class TabsComponent {
    private container: HTMLElement | null = null;
    private tabs: HTMLElement[] = [];
    private panels: HTMLElement[] = [];

    constructor() {
        this.container = document.querySelector<HTMLElement>('[data-tabs]');

        if (!this.container) {
            return;
        }

        this.tabs = Array.from(this.container.querySelectorAll('[data-tab-target]'));

        // On peuple directement le tableau des panneaux
        this.tabs.forEach(tab => {
            const targetId = tab.dataset.tabTarget;
            if (targetId) {
                const panel = this.container?.querySelector<HTMLElement>(targetId);
                if (panel) {
                    this.panels.push(panel);
                }
            }
        });

        this.attachEvents();
    }

    private attachEvents(): void {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', (event) => {
                this.selectTab(event.currentTarget as HTMLElement);
            });
        });
    }

    private selectTab(clickedTab: HTMLElement): void {
        const targetId = clickedTab.dataset.tabTarget;
        if (!targetId) {
            return;
        }

        const targetPanel = this.container?.querySelector<HTMLElement>(targetId);

        this.tabs.forEach(tab => {
            tab.classList.remove('active');
            tab.setAttribute('aria-selected', 'false');
        });

        this.panels.forEach(panel => {
            panel.classList.remove('active');
        });

        clickedTab.classList.add('active');
        clickedTab.setAttribute('aria-selected', 'true');

        if (targetPanel) {
            targetPanel.classList.add('active');
        }
    }
}

const tabs = new TabsComponent();